// LICENSE_CODE ZON
'use strict'; /*jslint react:true*/
import React from 'react';
import cn from 'classnames';
import {dur_to_str} from '/util/date.js';
import {fmt_money, bw_to_readable} from '../../utils/misc.js';
import {FAQ_LINK_VPN, UPTIME_BILLING} from '../../utils/constants.js';
import {Text} from '../../comp/text';
import {Icon} from '../../comp/icon';
import {Country} from '../../comp/country';
import './device.less';

const fmt_time = time=>dur_to_str(time, {sep: ' ', units: 2, precision: 1000});

const REASONS = {
    ip_type: 'Wrong IP type',
    ip_quality: 'Low quality IP',
    fraud_score: 'Low quality IP',
    country: 'Country not supported',
};

const decide_reason = banned=>{
    let res = REASONS[banned.reason]||'Other reasons';
    const det = banned.details||'';
    switch (banned.reason)
    {
    case 'ip_type':
        res += ` (detected as ${det.toUpperCase()})`;
        break;
    case 'ip_quality':
        res += ` (detected as ${det.toUpperCase()})`;
        break;
    case 'fraud_score':
        res += ` (High Risk)`;
        break;
    case 'country':
        res += ` (${det})`;
        break;
    }
    return res;
};

const advices = [
    'change your IP address',
    'remove other bandwidth sharing apps',
    'use residential IP address',
    'remove VPN',
    'do not use proxy',
];

const render_ban = data=>{
    if (!data.banned)
        return null;
    return <div className="ead_ban">
      <div className="ead_ban_item">
        <div className="ead_ban_header">
          <Icon className="ead_ban_icon" ico="warn" color="error" size="xs"/>
          <Text.xl bold className="ead_ban_title">
            Device is not earning
          </Text.xl>
        </div>
        <Text.m secondary className="ead_ban_details">
          {decide_reason(data.banned)}
        </Text.m>
        <div className="ead_ban_ip">
          <Text.m secondary>IP detected:</Text.m>
          <Text.m secondary mono bold className="ead_ip">
            {data.banned.ip}
          </Text.m>
        </div>
        <a className="ead_help" href={FAQ_LINK_VPN} target="_blank"
          rel="noreferrer noopener">
          <Icon className="ead_help_ico" ico="faq" color="error" size="m"/>
          Why am I seeing this?
        </a>
      </div>
      <div className="ead_ban_item">
        <div className="ead_ban_header">
          <Text.l className="ead_ban_title">Try the following:</Text.l>
        </div>
        <ul className="ead_advices">
          {advices.map((advice, i)=>
            <li key={i}><Text.m secondary>{advice}</Text.m></li>)}
        </ul>
      </div>
    </div>;
};

export function Device({data, className}){
    const units = UPTIME_BILLING.includes(data.billing) ? 'mo' : 'GB';
    return <div className={cn('ea_device', className)}>
      <Text.m tertiary>Device:</Text.m>
      <Text.xxl bold className="ead_title">{data.title}</Text.xxl>
      {data.uuid!=data.title && <Text.m mono tertiary>
        {data.uuid}</Text.m>}
      {render_ban(data)}
      <Text.m className="ead_label_stats">Stats</Text.m>
      <ul className="ead_stats">
        <li className="ead_stat">
          <Text.l tertiary>Balance:</Text.l>
          <Text.l mono>{fmt_money(data.earned)}</Text.l>
        </li>
        <li className="ead_stat">
          <Text.l tertiary>
            {units!='mo' ? 'Current usage:' : 'Current online time:'}
          </Text.l>
          <Text.l mono>
            {units!='mo'
                ? bw_to_readable(data.bw)
                : fmt_time(data.uptime)
            }
          </Text.l>
        </li>
        <li className="ead_stat">
          <Text.l tertiary>Rate:</Text.l>
          <Text.l mono>{fmt_money(data.rate)}/{units}</Text.l>
        </li>
        <li className="ead_stat">
          <Text.l tertiary>Total earned:</Text.l>
          <Text.l mono>{fmt_money(data.earned_total)}</Text.l>
        </li>
        <li className="ead_stat">
          <Text.l tertiary>
            {units!='mo' ? 'Total usage:' : 'Total online time:'}
          </Text.l>
          <Text.l mono>{units!='mo' ? bw_to_readable(data.total_bw) :
            fmt_time(data.total_uptime)}</Text.l>
        </li>
        <li className="ead_stat">
          <Text.l tertiary>Country:</Text.l>
          <div className="ead_country">
            {data.country
              ? <Country code={data.country} show_code font_size="l"/>
              : '-'
            }
          </div>
        </li>
        <li className="ead_stat">
          <Text.l tertiary>IP:</Text.l>
          <div className="ead_ips">
            {data.ips?.map(ip=><Text.l mono key={ip}>{ip}</Text.l>)}
          </div>
        </li>
      </ul>
    </div>;
}
